module.exports = __webpack_public_path__ + "img/wensuhaoli.7ed1b7ec.png";